import { Injectable } from '@angular/core';

interface RequestObject {
    id: {
        act_id: number;
        jwt: {
            uid: string;
        };
    };
    operation: string;
    app_cd?: string;
    from?: {
        schema: string;
        table: string;
    };
    where?: {
        [key: string]: any;
    };
    limit?: number;
    offset?: number;
    order?: string[];
    group?: string[];
    having?: {
        [key: string]: any;
    };
    include?: any;
}

@Injectable({
    providedIn: 'root'
})

export class RequestService {

    constructor() { }
    async processTerm(item) {
        const tech_nm = item.di_tech_nm;
        const title = item.di_bus_nm;
        const description = item.di_desc;
        const data_type_info = item.di_tcd_json.data_type;
        const dt_tcd = data_type_info.dt_tcd;
        const dt_tcd_json = data_type_info.dt_tcd_json || {};

        let properties: any = {
            type: dt_tcd.toLowerCase()
        };

        if (item.di_tcd_json.cl_type && item.di_tcd_json.cl_type.av_init) {
            properties.enum = item.di_tcd_json.cl_type.av_init.map(entry => entry[0]);
        }

        switch (dt_tcd) {
            case "STRING":
                properties.minLength = dt_tcd_json.min_len || 0;
                properties.maxLength = dt_tcd_json.max_len || 255;
                if (dt_tcd_json.pattern) {
                    properties.pattern = dt_tcd_json.pattern;
                }
                break;
            case "INTEGER":
                properties.type = "integer";
                // if (dt_tcd_json.precision !== undefined) {
                //     properties.minimum = 0;
                //     properties.maximum = Math.pow(10, dt_tcd_json.precision) - 1;
                // }
                // if (dt_tcd_json.signed) {
                //     properties.minimum = -properties.maximum;
                // }
                break;
            case "BOOLEAN":
                properties.type = "boolean";
                break;
            case "DECIMAL":
                properties.type = "number";
                // const precision = dt_tcd_json.precision || 10;
                // const scale = dt_tcd_json.scale || 0;
                // properties.minimum = 0;
                // properties.maximum = Math.pow(10, precision) - Math.pow(10, -scale);
                // if (dt_tcd_json.signed) {
                //     properties.minimum = -properties.maximum;
                // }
                break;
            case "JSON":
                properties.type = "object";
                properties.properties = dt_tcd_json.schema ? dt_tcd_json.schema : {};
                break;
            case "DATE":
                properties.type = "string";
                properties.format = "date";
                break;
            case "TIME":
                properties.type = "string";
                properties.format = "time";
                break;
            case "DATETIME":
                properties.type = "string";
                properties.format = "date-time";
                break;
            default:
                break;
        }

        if (item.di_tcd_json.nullable) {
            properties.type = [properties.type, "null"];
        }

        if (item.di_tcd_json.default && item.di_tcd_json.default.const !== undefined) {
            properties.default = item.di_tcd_json.default.const;
        }

        return {
            tech_nm,
            title,
            description,
            properties
        };
    }


    async buildRequestObject(act_id: number, uid: any, operation: string, schema?: string, table?: string, where?: { [key: string]: any }, app_cd?: string, limit?: number, offset?: number, order?: string[], group?: string[], having?: { [key: string]: any }, include?: string[]) {
        if (act_id !== undefined && uid && operation) {
            const request: RequestObject = {
                id: {
                    act_id: act_id,
                    jwt: {
                        uid: uid
                    }
                },
                operation: operation
            };
            if (schema && table) {
                request.from = {
                    schema: schema,
                    table: table
                };
            }
            if (where) {
                request.where = where;
            }
            if (app_cd) {
                request.app_cd = app_cd;
            }
            if (limit) {
                request.limit = limit;
            }
            if (offset) {
                request.offset = offset;
            }
            if (order) {
                request.order = order;
            }
            if (group) {
                request.group = group;
            }
            if (having) {
                request.having = having;
            }
            if (include) {
                request.include = include;
            }
            return request;
        } else {
            return null; 
        }
    }
    
    pfObj = {
        pf_path: { name: 'Physical File Path', description: 'Location of physical file in the datasource. - (a) For databases, this should be schema. (b) For file systems this should path of the directory where file is kept. If path begins with / then it is considered as absolute otherwise relative to data source home.' },
      
        default_ds: { name: 'Default Datastore', description: 'Select the default data source.' },
        pf_name: { name: 'Physical File Technical Name', description: 'Name of the physical file.(a) For databases, this should be the table name. - (b) For file systems this should be full file name including extension.' },
        pf_tcd: { name: 'Physical File Typecode', description: 'A code that classifies physical files according to its type. Allowed Values are - TBL, TXT, CSV ' },
        di_tech_nm: { name: 'Physical File Technical Name', description: 'Technical Name of the Physical file' },
        di_bus_nm: { name: 'Physical File Business Name', description: 'Business Name of the Physical file' },
        di_desc: { name: 'Physical File Description', description: 'description of the Physical file' },
        di_cd: { name: 'Physical File Unique Code', description: 'Unique Code of the Physical file' },
        charset: { name: 'charset', description: 'A code indicating character set.' },
        collating_seq: { name: 'collating sequence', description: 'A code indicating the order sequence that must be used for sorting and comparision purposes.' },
        comment: { name: 'Add Comments', description: 'Text representing comment of a user.' }


    };
    trObj = {
        di_tech_nm: {
            name: 'Term Technical Name',
            description: 'The technical name used by developers and IT professionals.'
        },
        di_bus_nm: {
            name: 'Term Business Name',
            description: 'The business-friendly name used by non-technical stakeholders.'
        },
        di_cd: {
            name: 'Term Unique Code',
            description: 'A unique identifier for the term used across systems.'
        },
        di_desc: {
            name: 'Term Description',
            description: 'A detailed explanation of what the term means and its usage.'
        },

        dt_tcd: {
            name: 'Term Datatype',
            description: 'select the term datatype'
        },
        maxLength: {
            name: 'Term Maximum Length',
            description: ''
        },
        minLength: {
            name: 'Term Minimum Length',
            description: ''
        },
        pattern: {
            name: 'Term Length',
            description: ''
        },
        collating_seq: { name: 'collating sequence', description: 'A code indicating the order sequence that must be used for sorting and comparision purposes.' },

        comment: { name: 'Add Comments', description: 'Text representing comment of a user.' },
        charset: { name: 'charset', description: 'A code indicating character set.' },
        surrogate: { name: 'surrogate', description: ' Surrogate Key is used when natural keys (derived from actual data) are either not unique or are too complex to use.' },
    };






}
